import React, { createContext, useContext, useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { DEFAULT_ENDPOINTS, DEFAULT_POLICY, DEFAULT_TAG, buildSeCode } from './constants'

const SeDebugContext = createContext(null)

export function SeDebugProvider ({ config, children }) {
  const { isSummitUser } = useAppContext()

  const endpoints = useMemo(() => ({
    list: config?.listEndpoint || DEFAULT_ENDPOINTS.list,
    mark: config?.markEndpoint || DEFAULT_ENDPOINTS.mark
  }), [config?.listEndpoint, config?.markEndpoint])

  const policy = config?.policy || DEFAULT_POLICY
  const tag = config?.tag || DEFAULT_TAG
  const devPolicy = config?.devPolicy || policy
  const devTag = config?.devTag || tag
  const showDebugControl = config?.showDebugControl !== false

  const prodSuffix = `${policy}:${tag}`
  const devSuffix = `${devPolicy}:${devTag}`
  const [suffix, setSuffix] = useState(isSummitUser ? devSuffix : prodSuffix)

  useEffect(() => {
    setSuffix(isSummitUser ? devSuffix : prodSuffix)
  }, [prodSuffix, devSuffix, isSummitUser])

  const value = useMemo(() => ({
    suffix,
    setSuffix,
    prodSuffix,
    devSuffix,
    showDebugControl,
    codes: {
      list: buildSeCode(endpoints.list, suffix),
      mark: buildSeCode(endpoints.mark, suffix)
    }
  }), [suffix, prodSuffix, devSuffix, showDebugControl, endpoints])

  return (
    <SeDebugContext.Provider value={value}>
      {children}
    </SeDebugContext.Provider>
  )
}

SeDebugProvider.propTypes = {
  config: PropTypes.object,
  children: PropTypes.node.isRequired
}

export function useSeCodes () {
  const ctx = useContext(SeDebugContext)
  if (!ctx) {
    const defaultSuffix = `${DEFAULT_POLICY}:${DEFAULT_TAG}`
    return {
      list: buildSeCode(DEFAULT_ENDPOINTS.list, defaultSuffix),
      mark: buildSeCode(DEFAULT_ENDPOINTS.mark, defaultSuffix)
    }
  }
  return ctx.codes
}

export function useSeDebug () {
  return useContext(SeDebugContext)
}
